import React from 'react'
import BackgroundImg from '../assets/images/hdb-dashboard-img.avif';
import BackgroundImgJpg from '../assets/images/hdb-dashboard-img-jpg.jpeg';
import BackgroundImgMobile from '../assets/images/hdb-dashboard-img-mobile.png';
import BackgroundImgCorppass from '../assets/images/hdb-corppass-dashboard.png';
import { P2Breadcrumb } from 'react-bootstrap-common-script';
import useIsMobile from '../hooks/use-is-mobile';
import { dashboardTrackingId } from '../utils/wogaa-ids';
import { useAppSelector } from '../redux/hook';
import { SingpassTypeEnum } from '../models/enum/singpass-type.enum';
import { useWogaa } from '../hooks/use-wogaa';

interface ApplicationCooDashboardLayoutProps{
  children: React.ReactNode;
  bannerTitle?: string;
}
function ApplicationCooDashboardLayout({bannerTitle = "Change in Flat Ownership Dashboard", ...props}:ApplicationCooDashboardLayoutProps) {
const { isMobile } = useIsMobile();
const singpassType = useAppSelector( (state) => state.auth.AuthenticationSlice.singPassType);

// WOGAA tracking for dashboard - auto start and complete (page view tracking)
useWogaa({
  trackingId: dashboardTrackingId,
  autoStart: true,
  autoComplete: true,
});

  return (
    <div className="polymer-application-coo-dashboard">
      <div className="polymer-application-coo-dashboard__main-column">
        <div className="polymer-application-coo-dashboard__top-section">
          <div className="polymer-application-coo-dashboard__breadcrumb-wrapper">
            <P2Breadcrumb
              pages={[
                { title: "Home", link: "https://www.hdb.gov.sg/" },
                { title: "Dashboard", link: "#" },
              ]}
            />
          </div>
          <p className="polymer-application-coo-dashboard__welcome-message-subtitle">Welcome to</p>
          <h1 className="polymer-application-coo-dashboard__welcome-message-title">{bannerTitle}</h1>
        </div>
        <div className="polymer-application-coo-dashboard__card shadow-sm">{props.children}</div>
      </div>
      <div className="polymer-application-coo-dashboard__background">
        <picture>
          {!isMobile && (
            <>
              <source
                className="polymer-application-coo-dashboard__background-image"
                srcSet={singpassType === SingpassTypeEnum.singpass ? BackgroundImg : BackgroundImgCorppass}
                type="image/avif"
              />
              <img
              className="polymer-application-coo-dashboard__background-image"
                src={singpassType === SingpassTypeEnum.singpass ? BackgroundImgJpg : BackgroundImgCorppass}
                alt="Banner of HDB flat"
              />
            </>
          )}

          {isMobile && (
            <>
              <img
                className="polymer-application-coo-dashboard__background-image"
                src={singpassType === SingpassTypeEnum.singpass ? BackgroundImgMobile : BackgroundImgCorppass}
                alt="Banner of HDB flat"
              />
            </>
          )}
        </picture>
      </div>
    </div>
  );

  return (
    <div className='polymer-application-coo-dashboard'>
      <div className='polymer-application-coo-dashboard__header'>
        <div className='polymer-application-coo-dashboard__header-banner'>
          <picture>
            {!isMobile && <>
              <source width={"auto"} height={"auto"} srcSet={singpassType === SingpassTypeEnum.singpass ? BackgroundImg : BackgroundImgCorppass} type="image/avif" />
              <img width={"auto"} height={"auto"} src={singpassType === SingpassTypeEnum.singpass ? BackgroundImgJpg : BackgroundImgCorppass} alt="Banner of HDB flat" />
            </>}

            {isMobile && <>
              <img width={"auto"} height={"auto"} src={singpassType === SingpassTypeEnum.singpass ? BackgroundImgMobile : BackgroundImgCorppass} alt="Banner of HDB flat" />
            </>}
          </picture>  
        </div>
        <div className='polymer-application-coo-dashboard__header-actions'>
          <div className='polymer-application-coo-dashboard__breadcrumb'>
            <P2Breadcrumb
              pages={[
                { title: "Home", link: "https://www.hdb.gov.sg/" },
                { title: "Dashboard", link: "#" },
              ]}
            />
          </div>
          {/* <FontResizingButton/> */}
        </div>
        <div className='polymer-application-coo-dashboard__header-actions'>
          <div className='polymer-application-coo-dashboard__welcome-message'>
            <p className='polymer-application-coo-dashboard__welcome-message_sub-title'>Welcome to</p>
            <h1 className='polymer-application-coo-dashboard__welcome-message_title'>Change in Flat Ownership Dashboard</h1>
          </div>
          <div></div>
        </div>

      </div>
      <div className='polymer-application-coo-dashboard__card shadow-sm'>
        {props.children}
      </div>
    </div>
  )
}

export default ApplicationCooDashboardLayout